import { render, staticRenderFns } from "./DataTablesHeaderColumnComponent.vue?vue&type=template&id=7a28957c&"
import script from "./DataTablesHeaderColumnComponent.vue?vue&type=script&lang=js&"
export * from "./DataTablesHeaderColumnComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/fi-self-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a28957c')) {
      api.createRecord('7a28957c', component.options)
    } else {
      api.reload('7a28957c', component.options)
    }
    module.hot.accept("./DataTablesHeaderColumnComponent.vue?vue&type=template&id=7a28957c&", function () {
      api.rerender('7a28957c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue_datatables/DataTablesHeaderColumnComponent.vue"
export default component.exports